import Image from "next/image";
import classNames from "classnames";
import { TRANSPARENT_PIXEL } from "lib/constants/shared";
import { createCloudflareLoader } from "utils";

type BlurUpImageProps = {
  src: string;
  alt: string;
  className?: string;
  width: number;
  height: number;
  blurDataURL?: string;
  sizes?: string;
  quality?: number;
};

const imageLoader = createCloudflareLoader({
  fit: "scale-down",
  format: "auto",
});

const BlurUpImage = ({
  src,
  alt,
  className,
  width,
  height,
  blurDataURL,
  sizes,
  quality,
  ...props
}: BlurUpImageProps) => {
  // const [isLoaded, setIsLoaded] = useState(false);

  return (
    <Image
      // onLoad={() => setIsLoaded(true)}
      loader={imageLoader}
      src={src}
      alt={alt}
      width={width}
      height={height}
      quality={quality || 75}
      blurDataURL={blurDataURL || TRANSPARENT_PIXEL}
      placeholder="blur"
      className={classNames(
        className,
        `will-change-[filter] [transition:filter_0.25s]`
        // {
        //   "blur-[10px]": !isLoaded,
        // }
      )}
      sizes={
        sizes || "(max-width: 768px) 100vw, (max-width: 1200px) 100vw, 100vw"
      }
      {...props}
    />
  );
};

export default BlurUpImage;
